import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { attempt } from "@jfdi/attempt";
import is from "@sindresorhus/is";
import Maths from "../../lib/expressions";

// Lazy load to avoid circular dependency in @rjsf/core
let BaseInput = null;
let DateWidget = null;
function getBaseInput() {
    if (!BaseInput) {
        BaseInput = require("@rjsf/core/lib/components/widgets/BaseInput").default;
    }
    return BaseInput;
}
function getDateWidget() {
    if (!DateWidget) {
        DateWidget = require("@rjsf/core/lib/components/widgets/DateWidget").default;
    }
    return DateWidget;
}

const math = Maths();

export const CalculatedWidget = props => {
    const {
        schema: { format },
        formContext: { formData },
        options: { formula, hidden = false },
        onChange
    } = props;
    const [value, setValue] = useState();

    useEffect(() => {
        const cleanedFormula = formula.startsWith("=") ? formula.split(1) : formula;
        const [error, result] = attempt(() => math.evaluate(cleanedFormula, formData));
        // console.log("Calc", result, error?.text);
        if (!(error || is.nan(result))) {
            const dispVal = is.date(result) ? result.toISOString().split("T")[0] : result;
            setValue(dispVal);
            onChange(dispVal);
        }
    }, [formData, formula, onChange]);

    const Input = format === "date" ? getDateWidget() : getBaseInput();

    return (
        <Form.Group className="mb-0" style={hidden ? { display: "none" } : undefined}>
            <Form.Label className={props.rawErrors ? "text-danger" : ""}>{props.label}</Form.Label>
            <Input {...props} value={value} />
        </Form.Group>
    );
};
